const url = "https://vizfixer-api.idvxlab.com:8008"

export {url}